export default {
    USER: 'USER',
    ADMIN: 'ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
    ONBOARDING_ADMIN: 'ONBOARDING_ADMIN',
};
